import VisualReport from "components/visual-report/visual-report"

export default function setListeners() {
  const buttons = document.querySelectorAll("[data-visual-report]")

  Array.from(buttons).forEach((button) => {
    const shouldRemove = button.dataset.visualReportRemove
    let canSubmit = true

    button.addEventListener("click", (e) => {
      e.preventDefault()
      if (canSubmit)
        VisualReport().then((instance) => {
          instance.$on("submitted", (submitted) => {
            canSubmit = !submitted
            if (submitted) button.classList.add("is-submitted")
            else button.classList.remove("is-submitted")

            if (submitted && shouldRemove) button.remove()
          })
        })
    })
  })

  const { FCGON } = window

  // Automatic startup on the dedicated sign up page
  if (FCGON && FCGON.visual_report_immediately) {
    VisualReport()
  }
}
